<template>
    <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@charset "utf-8";
*{margin: 0px;border: 0px;padding: 0px;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;-webkit-tap-highlight-color: rgba(0, 0, 0, 0);touch-action: pan-y;}
li{list-style: none; }
a{display:block;text-decoration: none; color: inherit;-webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; -webkit-user-select: none;}
img{display: block;}
html{font-size: 14px;}
body{ color: #000; overflow-x: hidden;position: relative; background:#f8f9fb; }
h1,h2,h3,h4,h5,h6,b{font-weight: normal;}
em,i{font-style: normal;}
textarea {-webkit-appearance: none;resize: none; font-family:inherit ; }
select{appearance:none; -moz-appearance:none; -webkit-appearance:none; }
.hide{ display: none; }
.op0{opacity: 0;}
.show{ display: block; }
.oh1{ text-overflow: ellipsis; white-space: nowrap; overflow: hidden; }
.cle::after,.wrap::after{content: ""; display: block; height:0; clear:both; visibility:hidden;}
.fl{float: left;}
.fr{float: right;}
.tc{text-align: center;}
.tr{text-align: right;}
.tl{text-align: left;}
.w100{width: 100%!important;}
.h100{height: 100%!important; }
.page-pagination{padding: 20px 10px; }
.filter_panel{width: 100%; display: flex; }
.filter_panel .filter_form{flex: 1; }
.filter_panel .filter_button.on{margin-bottom: 10px; }
.scroll_class{width: 100%; overflow: hidden; overflow-y: auto; }
#app{height: 100vh!important;}
</style>



// WEBPACK FOOTER //
// src/App.vue